import React from 'react';
import Breadcrumb from '../components/ui/Breadcrumb';
import DesignerShell from '../components/designer/DesignerShell';

const Designer = () => {
  return (
    <div className="flex flex-col h-[calc(100vh-4rem)]">
      <div className="container mx-auto px-4 pt-4 pb-2">
        <Breadcrumb
          items={[
            { label: 'Dashboard', to: '/dashboard' },
            { label: 'Landing Zone Designer' },
          ]}
        />
        <h1 className="text-2xl font-bold mt-2 text-gray-900 dark:text-gray-100">
          Landing Zone Designer
        </h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">
          Visually design Azure landing zones and export Terraform code.
        </p>
      </div>
      <div className="flex-1 overflow-hidden border-t border-gray-200 dark:border-gray-700">
        <DesignerShell />
      </div>
    </div>
  );
};

export default Designer;
